export default function notify(messageHTML) {
	const $notificationContainer = document.querySelector("[data-notifications]");
	$notificationContainer.innerHTML = messageHTML;
	$notificationContainer.classList.add("is-active");
	window.setTimeout(_ => {
		$notificationContainer.classList.remove("is-active");
	}, 5000);
}
